angular.module('impactx.login').controller('LoginErrorCtrl', LoginErrorCtrl);

LoginErrorCtrl.$inject = ['LoginService', '$securityManager', '$routeParams', '$mdDialog'];

function LoginErrorCtrl(LoginService, $securityManager, $routeParams, $mdDialog) {
    var error = $routeParams.error;
    var errorDescription = $routeParams.errordescription;
    $mdDialog.show({
        templateUrl: 'modules/login/templates/login.error.tmpl.html',
        controller: 'LoginErrorDialogCtrl',
        controllerAs: "loginErrorDialogCtrl",
        clickOutsideToClose: false,
        escapeToClose: false,
        fullscreen: false,
        locals: {
            error: error,
            errorDescription: errorDescription
        }
    });
}